import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@wix/da-shared-react/pkg/Button';
import { useFlag } from '@wix/da-shared-react/pkg/redux/flags/hooks/useFlag';
import SortBy from '../../_partials/WidgetEditControls/SortBy';
import ConfigPopover from '../../_partials/ConfigPopover';

import s from './WatchedDeviantsConfigPopover.scss';

export interface Props {
  moduleId: number;
  withManageLink?: boolean;
  onClose(): void;
}

export const WatchedDeviantsConfigPopover: React.FC<Props> = props => {
  const { t } = useTranslation();
  const swapWatchWithFollow = useFlag('swap_watch_follow');
  return (
    <ConfigPopover withPaddings={false} onClose={props.onClose} width={230}>
      {props.withManageLink && (
        <Button
          target="_blank"
          href="/watching"
          className={s['manage-button']}
          view="b14"
          height="medium"
        >
          {t(
            swapWatchWithFollow
              ? 'widgets.watching.editFollowList'
              : 'widgets.watching.editWatchList'
          )}
        </Button>
      )}
      <SortBy
        moduleId={props.moduleId}
        paramName="sortBy"
        labels={{
          newest: 'common.sortOrder.newest',
          oldest: 'common.sortOrder.oldest',
        }}
        close={props.onClose}
      />
    </ConfigPopover>
  );
};
WatchedDeviantsConfigPopover.displayName = 'WatchedDeviantsConfigPopover';

export default WatchedDeviantsConfigPopover;
